import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as creditBillActions } from "reducers/creditBills";
import * as i18n from "util/i18n";

export const useTags = (tabOption) => {
    const dispatch = useDispatch();
    const [tags, setTags] = useState([]);
    const { filters } = useSelector((state) => state.creditBills);

    const commonTagOptions = {
        issueDateFrom: { id: "issueDateRange", text: i18n.get("creditBill.emittedRange.label") },
        paymentDueDateFrom: { id: "paymentDueDateRange", text: i18n.get("creditBill.expiredRange.label") },
        invoiceStatus: { id: "invoiceStatus", text: i18n.get("creditBill.invoiceStatus.label") },
    };

    const tagOptions = {
        EMITTED: {
            ...commonTagOptions,
            buyerCuit: { id: "buyerCuit", text: i18n.get("creditBill.buyerCuit.tag") },
            holderCuit: { id: "holderCuit", text: i18n.get("creditBill.holderCuit.tag") },
        },
        IN_TENURE: {
            ...commonTagOptions,
            buyerCuit: { id: "buyerCuit", text: i18n.get("creditBill.buyerCuit.tag") },
            issuerCuit: { id: "issuerCuit", text: i18n.get("creditBill.issuerCuit.tag") },
        },
        RECEIVED: {
            ...commonTagOptions,
            holderCuit: { id: "holderCuit", text: i18n.get("creditBill.holderCuit.tag") },
            issuerCuit: { id: "issuerCuit", text: i18n.get("creditBill.issuerCuit.tag") },
        },
        TO_PAY: {
            ...commonTagOptions,
            holderCuit: { id: "holderCuit", text: i18n.get("creditBill.holderCuit.tag") },
            issuerCuit: { id: "issuerCuit", text: i18n.get("creditBill.issuerCuit.tag") },
        },
    };

    useEffect(() => {
        const activeTags = Object.entries(filters)
            .filter(
                (activeFilters) =>
                    !activeFilters.includes("") && !activeFilters.includes("TODOS") && !activeFilters.includes(null),
            )
            .map((filter) => filter[0])
            .filter((filterKey) => !!tagOptions[tabOption][filterKey])
            .map((key) => tagOptions[tabOption][key]);

        setTags(activeTags);
    }, [filters]);

    const handleDelete = (i) => {
        const deletedFilter = tags.find((tag, index) => index === i).id;

        if (
            deletedFilter !== "issueDateRange" &&
            deletedFilter !== "paymentDueDateRange" &&
            deletedFilter !== "invoiceStatus"
        ) {
            const tagFilters = {
                ...filters,
                pageNumber: 1,
                [deletedFilter]: null,
            };
            dispatch(creditBillActions.setCreditBillFilters(tagFilters));
            dispatch(creditBillActions.getCreditBills(tagFilters));
            return;
        }

        if (deletedFilter === "issueDateRange") {
            const tagFilters = {
                ...filters,
                pageNumber: 1,
                issueDateFrom: null,
                createdTo: null,
            };
            dispatch(creditBillActions.setCreditBillFilters(tagFilters));
            dispatch(creditBillActions.getCreditBills(tagFilters));
            return;
        }

        if (deletedFilter === "paymentDueDateRange") {
            const tagFilters = {
                ...filters,
                pageNumber: 1,
                paymentDueDateFrom: null,
                paymentDueDateTo: null,
            };
            dispatch(creditBillActions.setCreditBillFilters(tagFilters));
            dispatch(creditBillActions.getCreditBills(tagFilters));

            return;
        }

        if (deletedFilter === "invoiceStatus") {
            const tagFilters = {
                ...filters,
                pageNumber: 1,
                invoiceStatus: "TODOS",
            };
            dispatch(creditBillActions.setCreditBillFilters(tagFilters));
            dispatch(creditBillActions.getCreditBills(tagFilters));
        }
    };

    const handleCleanFilters = () => {
        const clearFilters = {
            ...filters,
            pageNumber: 1,
            issueDateFrom: null,
            issueDateTo: null,
            paymentDueDateFrom: null,
            paymentDueDateTo: null,
            invoiceStatus: "TODOS",
            holderCuit: null,
            buyerCuit: null,
            issuerCuit: null,
        };
        dispatch(creditBillActions.setCreditBillFilters(clearFilters));
        dispatch(creditBillActions.getCreditBills(clearFilters));
    };

    return { tags, handleDelete, handleCleanFilters };
};

export default useTags;
